'use strict';

define('vb/action/builtin/sendWebSocketMessageAction',['vb/action/action', 'vb/private/utils'], (Action, Utils) => {
  /**
   * Sends a message over a WebSocket connection.
   * @extends Action
   * @category Action
   */
  class SendWebSocketMessageAction extends Action {
    /**
     * Performs the action of sending a message over a WebSocket connection.
     *    @async
     *    @param {object} parameters - The parameters required to perform the action.
     *    @param {WebSocket} parameters.webSocket - The WebSocket connection to send the message through.
     *    @param {*} parameters.message - The message to be sent. Can be any type, but will be stringified if it's an
     *    object or array.
     *    @returns {Promise} A promise that resolves with the outcome of the action.
     */
    // eslint-disable-next-line class-methods-use-this
    async perform(parameters) {
      const { webSocket, message } = parameters;

      // If the message is a JSON object or array, we need to stringify before sending
      const convertedMsg = Utils.isObjectOrArray(message) ? JSON.stringify(message) : message;

      try {
        await webSocket.send(convertedMsg);
        return Action.createSuccessOutcome();
      } catch (error) {
        return Action.createFailureOutcome('Error sending message to the web socket:', error);
      }
    }
  }

  return SendWebSocketMessageAction;
});

